import { Injectable } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PagePerformanceAuditInfoService } from '@client/app/modules/page-performance/services/page-performance-audit-info/page-performance-audit-info.service';
import { AuditImpactService } from '@client/app/modules/page-performance/services/audit-impact/audit-impact.service';

@Injectable({
    providedIn: 'root',
})
export class PerformanceAuditsParserService {
    constructor (
        private translateService: TranslateService,
        private auditImpactService: AuditImpactService,
        private performanceAuditInfoService: PagePerformanceAuditInfoService,
    ) {}

    private getHeadlines (): string[] {
        return [
            this.translateService.getString('Audit'),
            this.translateService.getString('Difficulty'),
            this.translateService.getString('Priority'),
        ];
    }

    parse (data: any[]): string[][] {
        if (!data?.length) {
            return [];
        }

        const csv: string[][] = [];
        csv.push(this.getHeadlines());

        for (const currentData of data) {
            const entry: string[] = [
                currentData.displayValue ? `${currentData.title} - ${currentData.displayValue}` : currentData.title,
                this.performanceAuditInfoService.getDifficulty(currentData.id),
                this.auditImpactService.getImpactTranslation(currentData),
            ];

            csv.push(entry);
        }
        return csv;
    }
}
